import { render } from "./AboutPage.vue?vue&type=template&id=48325b98"
import script from "./AboutPage.vue?vue&type=script&lang=js"
export * from "./AboutPage.vue?vue&type=script&lang=js"

import "./AboutPage.vue?vue&type=style&index=0&id=48325b98&lang=css"

import exportComponent from "/Users/gareth/Documents/Maps/Projects/globes-that-were/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__